import {UserSelectorProps} from "./types";
import SearchSelect from "@ui-components/SearchSelect";
import React from "react";
import {ExclamationCircleIcon} from "@heroicons/react/24/outline";

export const UserSelector = ({
  label,
  visible,
  blocked,
  disabled,
  required,
  value,
  onChange,
  options,
  loadOptions,
  defaultOptions,
  warnings,
  ...rest
}: UserSelectorProps) => {

  if (!visible)
    return null;

  return (
    <div className="flex flex-col gap-2">
      {/*@ts-ignore*/}
      <SearchSelect
        label={<span>
          {label}
          {required && <span className="text-red-500">{" "}*</span>}
        </span>}
        loadOptions={loadOptions}
        options={options}
        value={value}
        defaultOptions={defaultOptions}
        onChange={onChange}
        isDisabled={blocked || disabled}
        isClearable={!blocked}
        {...rest}
      />
      <div className="-mt-2">
        {warnings?.map((message, idx) => (
          <p key={idx} className="flex flex-row gap-1.5 items-start text-xs text-gray-500">
            <ExclamationCircleIcon className="w-4 flex-shrink-0" style={{marginTop: "0.1em"}} />
            <span>{message}</span>
          </p>
        ))}
      </div>
    </div>
  )
}